var _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductIa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 195,
    viewBox: "0 0 332 195",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.231445,
    y: 0.0551758,
    width: 102.791,
    height: 53.5672,
    rx: 19,
    fill: "url(#paint0_linear_481_93)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.231445,
    y: 94.8835,
    width: 217.164,
    height: 99.1716,
    rx: 19,
    fill: "url(#paint1_linear_481_93)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 172L40.9707 153.22C48.294 146.662 59.1867 146.062 67.1862 151.776L69.0238 153.088C72.5854 155.632 76.8529 157 81.2298 157H107.658C112.688 157 117.521 155.044 121.135 151.547V151.547C127.045 145.827 135.922 144.461 143.279 148.139L147.044 150.022C155.33 154.165 165.351 152.389 171.709 145.652L194.5 121.5",
    stroke: "#F8F8F8",
    strokeWidth: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 228.978,
    y: 94.8835,
    width: 102.791,
    height: 99.1716,
    rx: 19,
    fill: "url(#paint2_linear_481_93)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 114.604,
    y: 0.0551758,
    width: 102.791,
    height: 53.5672,
    rx: 19,
    fill: "url(#paint3_linear_481_93)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 228.978,
    y: 0.0551758,
    width: 102.791,
    height: 53.5672,
    rx: 19,
    fill: "url(#paint4_linear_481_93)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0898,
    y: 9.46558,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0898,
    y: 78.9583,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "url(#paint5_linear_481_93)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 241.283,
    y: 78.9583,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "url(#paint6_linear_481_93)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 126.91,
    y: 9.46558,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 241.283,
    y: 9.46558,
    width: 57.1866,
    height: 9.41045,
    rx: 4.70522,
    fill: "#F8F8F8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_481_93",
    x1: 51.627,
    y1: 0.0551758,
    x2: 51.627,
    y2: 53.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_481_93",
    x1: 108.814,
    y1: 94.8835,
    x2: 108.814,
    y2: 194.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_481_93",
    x1: 280.373,
    y1: 94.8835,
    x2: 280.373,
    y2: 194.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_481_93",
    x1: 166,
    y1: 0.0551758,
    x2: 166,
    y2: 53.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_481_93",
    x1: 280.373,
    y1: 0.0551758,
    x2: 280.373,
    y2: 53.6223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_481_93",
    x1: 39.6831,
    y1: 78.9583,
    x2: 39.6831,
    y2: 88.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_481_93",
    x1: 269.876,
    y1: 78.9583,
    x2: 269.876,
    y2: 88.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087ACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#179CF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIa1);
export default __webpack_public_path__ + "static/media/product-ia-1.284059541c41aba4f266f7f3dd92efdd.svg";
export { ForwardRef as ReactComponent };